import React from 'react';
import { Icon } from '../';

export const CombinedButton = ({ name, icon = 'close', iconSize = "0.375rem", onClick, dataSelector='data-test', ...props }) => {
    return (
        <div className='button__combined' onClick={onClick} {...props} data-selector={dataSelector}>
            <div className='button-icon'>
                <Icon name={icon} size={iconSize}/>
            </div>
            <span>{name}</span>
        </div>
    )
}

export default CombinedButton;